import { useNuxtApp, useRequestHeaders } from 'nuxt/app'
import { normalizeCountryCodeValue, useAppStore } from '../stores/app'
import { MY_COUNTRY_COOKIE_NAME } from '../utils/countryContext'

export type RouteTarget = {
  readonly fullPath: string
}

const initMyCountryFromCookie = (appStore: ReturnType<typeof useAppStore>) => {
  const myCountryFromCookie = normalizeCountryCodeValue(useAppCookie(MY_COUNTRY_COOKIE_NAME).value)

  if (!appStore.myCountry && myCountryFromCookie) {
    appStore.setMyCountry({ myCountry: myCountryFromCookie })
  }
}

export const initSharedAppHost = async (to: Readonly<RouteTarget>) => {
  const nuxtApp = useNuxtApp()
  const hostHeader = useRequestHeaders(['host']).host
  const initialHost = hostHeader || (typeof window !== 'undefined' ? window.location.host : '')
  const host = initialHost.includes('aws.') ? initialHost.replace('aws.', '') : initialHost
  const appStore = useAppStore(nuxtApp.$pinia)

  appStore.setHostend(host)
  appStore.setAllhost(`https://${host}${to.fullPath}`)
  appStore.setPath(to.fullPath)
  appStore.setcookieHost(host.split(':')[0] ?? host)
  initMyCountryFromCookie(appStore)
}
